<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRenderStatusComposable } from '../useRenderStatusComposable';

interface Props {
  ruleData: object;
}
defineProps<Props>();

const { t } = useI18n({ useScope: 'global' });
const { renderClass, renderStatus, renderStatusYesNo } = useRenderStatusComposable();
</script>
<template>
  <div class="flight-rule mt-4">
    <div v-if="ruleData.flightNoValid === false">
      <div class="mt-2 mb-4 ml-4 font-bold text-lg text-900">{{ t('rule.flight_no_invalid') }}</div>
    </div>
    <div v-else>
      <div v-if="ruleData.ruleFlightDisplay.flightEmpty" class="mt-2 mb-4 ml-4 font-bold text-lg text-900">{{ t('rule.flight_rule.flight_empty') }}</div>
      <div v-if="ruleData.ruleFlightDisplay.flightRuleNotFound" class="mt-2 mb-4 ml-4 font-bold text-lg text-900">{{ t('rule.flight_rule.rule_not_found') }}</div>
      <div v-if="ruleData.ruleFlightDisplay.flightNotValidWorksheet" class="mt-2 mb-4 ml-4 font-bold text-lg text-900">{{ t('rule.flight_rule.flight_not_valid') }}</div>
    </div>
    <div class="mt-2 ml-4">
      <ul>
        <li v-if="ruleData.ruleFlightDisplay.flightRule !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.flight_rule') }} <span :class="renderClass(ruleData.ruleFlightDisplay.flightRule)">({{ renderStatus(ruleData.ruleFlightDisplay.flightRule) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.FBR !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.fbr') }} <span :class="renderClass(ruleData.ruleFlightDisplay.FBR)">({{ renderStatusYesNo(ruleData.ruleFlightDisplay.FBR) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.FBRDepartureDate !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.fbr_departure_date') }} <span :class="renderClass(ruleData.ruleFlightDisplay.FBRDepartureDate)">({{ renderStatus(ruleData.ruleFlightDisplay.FBRDepartureDate) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.FBRSeatsInRule !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.fbr_seats_in_rule') }} <span :class="renderClass(ruleData.ruleFlightDisplay.FBRSeatsInRule)">({{ renderStatus(ruleData.ruleFlightDisplay.FBRSeatsInRule) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.FBRSeatsFClass !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.fbr_seats_f_class') }} <span :class="renderClass(ruleData.ruleFlightDisplay.FBRSeatsFClass)">({{ renderStatus(ruleData.ruleFlightDisplay.FBRSeatsFClass) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.seats !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.seats') }} <span :class="renderClass(ruleData.ruleFlightDisplay.seats)">({{ renderStatus(ruleData.ruleFlightDisplay.seats) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.FBRSeatsYClass !== undefined" class="text-lg mt-1">
          {{ $t('rule.flight_rule.fbr_seats_y_class_number', { number: ruleData.flightLog[0].maxYClass }) }} <span :class="renderClass(ruleData.ruleFlightDisplay.FBRSeatsYClass)">({{ renderStatus(ruleData.ruleFlightDisplay.FBRSeatsYClass) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.departureDate !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.departure_date') }} <span :class="renderClass(ruleData.ruleFlightDisplay.departureDate)">({{ renderStatus(ruleData.ruleFlightDisplay.departureDate) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.duration !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.duration') }} <span :class="renderClass(ruleData.ruleFlightDisplay.duration)">({{ renderStatus(ruleData.ruleFlightDisplay.duration) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.fClass !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.f_class') }} <span :class="renderClass(ruleData.ruleFlightDisplay.fClass)">({{ renderStatus(ruleData.ruleFlightDisplay.fClass) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.fClass80 !== undefined" class="text-lg mt-1">
          {{ $t('rule.flight_rule.f_class_number', { number: ruleData.flightLog[0].minFClass }) }} <span :class="renderClass(ruleData.ruleFlightDisplay.fClass80)">({{ renderStatus(ruleData.ruleFlightDisplay.fClass80) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.yClass !== undefined" class="text-lg mt-1">
          {{ $t('rule.flight_rule.y_class_number', { number: ruleData.flightLog[0].maxYClass }) }}<span :class="renderClass(ruleData.ruleFlightDisplay.yClass)">({{ renderStatus(ruleData.ruleFlightDisplay.yClass) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.sharedRisk !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.shared_risk') }} <span :class="renderClass(ruleData.ruleFlightDisplay.sharedRisk)">({{ renderStatusYesNo(ruleData.ruleFlightDisplay.sharedRisk) }})</span>
        </li>
        <li v-if="ruleData.ruleFlightDisplay.flightCost !== undefined" class="text-lg mt-1">
          {{ t('rule.flight_rule.flight_cost') }} <span :class="renderClass(ruleData.ruleFlightDisplay.flightCost)">({{ renderStatus(ruleData.ruleFlightDisplay.flightCost) }})</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.box-border {
  border: 1px solid #dee2e6;
  padding: 8px;
  text-align: center;
}
</style>
